import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { connect, ReactReduxContext } from 'react-redux';
import LocationInfo from './Location';
import ChangeLocation from './ChangeLocation';
import Modal from '../modal/Modal';
import WaitlistForm from '../forms/Waitlist';
import WaitlistButton from '../forms/WaitlistButton'; // Utilities

import * as UTIL from '../../util';
import { locationDuck } from '../../ducks/location';
import { waitlistDuck } from '../../ducks/waitlist';
import { cartDuck } from '../../ducks/cart'; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';
import { FiChevronDown } from "react-icons/fi";
var locationOperations = locationDuck.operations;
var waitlistOperations = waitlistDuck.operations;
import { Container, Row, Col, Button } from 'react-bootstrap';
import MediaQuery from 'react-responsive';

var LocationBanner = /*#__PURE__*/function (_Component) {
  _inherits(LocationBanner, _Component);

  var _super = _createSuper(LocationBanner);

  function LocationBanner(props) {
    var _this;

    _classCallCheck(this, LocationBanner);

    _this = _super.call(this, props);
    _this.state = {
      changeLocationActive: false,
      waitlistActive: props.waitlistActive,
      isLoading: props.isLoading,
      isError: props.isError,
      isWaitlisLoading: props.waitlistLoading,
      err: props.err,
      results: {},
      location: {},
      cart: props.cart,
      isCartAvailable: false,
      cartLength: 0
    };
    _this.handleShowModal = _this.handleShowModal.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this)); // this.changeLocation = this.changeLocation.bind(this);

    return _this;
  }

  _createClass(LocationBanner, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.isLoading !== this.props.isLoading) {
        this.setState({
          isLoading: newProps.isLoading
        });
      }

      if (newProps.isError !== this.props.isError) {
        this.setState({
          isError: newProps.isError,
          err: newProps.err
        });
      }

      if (newProps.results !== this.props.results) {
        this.setState({
          results: newProps.results
        }); // if(typeof this.props.location === 'undefined' || this.props.location === null) {
        //   this.props.setLocation(newProps.results[0]);
        // }
      }

      if (newProps.additionalResults !== this.props.additionalResults) {
        this.setState({
          additionalResults: newProps.additionalResults
        });
      }

      if (newProps.location !== this.props.location) {
        this.setState({
          location: newProps.location
        });
      }

      if (newProps.waitlistActive !== this.props.waitlistActive) {
        this.setState({
          waitlistActive: newProps.waitlistActive
        });
      }

      if (newProps.waitlistLoading !== this.props.waitlistLoading) {
        this.setState({
          waitlistLoading: newProps.waitlistLoading
        });
      }

      if (newProps.waitlistConfirmation !== this.props.waitlistConfirmation) {
        this.setState({
          waitlistConfirmation: newProps.waitlistConfirmation
        });
      }

      if (newProps.changeLocationModal !== this.props.changeLocationModal) {
        this.setState({
          changeLocationModal: newProps.changeLocationModal
        });
      }

      if (newProps.cart !== this.props.cart) {
        var _newProps$cart, _newProps$cart$foodIt, _newProps$cart2, _newProps$cart2$cater;

        if (((_newProps$cart = newProps.cart) === null || _newProps$cart === void 0 ? void 0 : (_newProps$cart$foodIt = _newProps$cart.foodItems) === null || _newProps$cart$foodIt === void 0 ? void 0 : _newProps$cart$foodIt.length) > 0 || ((_newProps$cart2 = newProps.cart) === null || _newProps$cart2 === void 0 ? void 0 : (_newProps$cart2$cater = _newProps$cart2.caterItems) === null || _newProps$cart2$cater === void 0 ? void 0 : _newProps$cart2$cater.length) > 0) {
          var _newProps$cart3, _newProps$cart3$foodI, _newProps$cart4, _newProps$cart4$cater;

          this.setState({
            isCartAvailable: true,
            cartLength: ((_newProps$cart3 = newProps.cart) === null || _newProps$cart3 === void 0 ? void 0 : (_newProps$cart3$foodI = _newProps$cart3.foodItems) === null || _newProps$cart3$foodI === void 0 ? void 0 : _newProps$cart3$foodI.length) + ((_newProps$cart4 = newProps.cart) === null || _newProps$cart4 === void 0 ? void 0 : (_newProps$cart4$cater = _newProps$cart4.caterItems) === null || _newProps$cart4$cater === void 0 ? void 0 : _newProps$cart4$cater.length)
          });
        } else {
          this.setState({
            isCartAvailable: false
          });
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (UTIL.locationUrl() !== '') {
        this.props.requestFromUrl(UTIL.locationUrl()); // Give it a bit of time for redux to update

        setTimeout(function () {
          _this2.props.getLocationFromUrl();

          if (UTIL.waitlistUrl()) {
            _this2.handleShowModal();
          }
        }, 50);
      }

      var locationIds = UTIL.locationIdsUrl();

      if (locationIds.vendorid || locationIds.cateringid) {
        setTimeout(function () {
          _this2.props.requestById(locationIds);

          if (UTIL.waitlistUrl()) {
            _this2.handleShowModal();
          }
        }, 50);
      }
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      return this.props.toggleWaitlist();
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      return this.props.toggleWaitlist();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var ga = function ga() {
        var data = {
          gtm: {
            uniqueEventId: '25',
            elementId: "banner-joinwaitlist"
          },
          event: 'gtm.click'
        };
        gaTracker(data);
      };

      var ctaClick = function ctaClick() {
        ga();

        _this3.handleShowModal(true);
      };

      var waitListTitle = this.props.showForm ? "Join the Wait List" : "";
      return !UTIL.hideFooterHeader() && /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
          show: _this3.state.waitlistActive,
          hide: _this3.handleClose,
          title: waitListTitle
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(WaitlistForm, {
          store: _this3.props.store,
          location: _this3.props.location,
          results: _this3.props.results,
          confirmation: _this3.props.waitlistConfirmation,
          isLoading: _this3.props.waitlistLoading,
          isError: _this3.state.isError,
          changeHandler: _this3.props.waitlistInputHandler // submitHandler={this.props.waitlistSubmitHandler}
          ,
          disclaimer: _this3.props.disclaimer
        }))), /*#__PURE__*/React.createElement(Modal, {
          locationColor: "yellow-200",
          size: "lg",
          className: "cb-modal--large",
          show: _this3.state.changeLocationModal,
          hide: _this3.props.toggleChangeModal,
          hideCloseButton: true //title="Change Location"

        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ChangeLocation, {
          store: _this3.props.store,
          setStoreHandler: _this3.props.toggleChangeModal,
          showCurrent: false,
          results: _this3.props.results,
          additionalResults: _this3.props.additionalResults,
          changeLocationHandler: _this3.props.toggleChangeModal
        }))), /*#__PURE__*/React.createElement("div", {
          className: "cb-location-banner"
        }, /*#__PURE__*/React.createElement(Container, {
          className: "h-100"
        }, /*#__PURE__*/React.createElement(Row, {
          className: "h-100"
        }, /*#__PURE__*/React.createElement(MediaQuery, {
          maxWidth: 990
        }, /*#__PURE__*/React.createElement(Col, {
          className: "d-flex justify-content-start align-items-center cb-location-banner__info"
        }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
          sm: "10",
          xs: "10"
        }, /*#__PURE__*/React.createElement(LocationInfo, {
          location: _this3.props.location,
          store: _this3.props.store,
          isLoading: _this3.props.isLoading,
          isError: _this3.props.isError,
          err: _this3.props.err,
          changeLocationHandler: _this3.props.toggleChangeModal
        })))), !_this3.props.isLoading ? /*#__PURE__*/React.createElement(Col, {
          className: "d-flex justify-content-end align-items-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "cb-button-group  d-flex"
        }, Boolean(_this3.props.temporarilyClosed) && /*#__PURE__*/React.createElement("span", {
          className: "d-flex",
          style: {
            'maxWidth': '260px'
          }
        }, "This location is temporarily closed"), Boolean(_this3.props.orderOnline) && /*#__PURE__*/React.createElement("span", {
          className: "d-flex",
          style: {
            'maxWidth': '260px'
          }
        }, "Online ordering is currently unavailable.", /*#__PURE__*/React.createElement("wbr", null), " Please call the store to place your order"), !_this3.props.temporarilyClosed && /*#__PURE__*/React.createElement(React.Fragment, null, _this3.props.waitlistAvailable && /*#__PURE__*/React.createElement(WaitlistButton, {
          store: _this3.props.store,
          ctaClick: ctaClick
        }), /*#__PURE__*/React.createElement("a", {
          href: "/menu",
          className: "cb-button-primary btn-sm",
          onClick: ga
        }, !_this3.state.isCartAvailable ? 'Order Online' : 'Keep Shopping'), Boolean(_this3.state.isCartAvailable) && /*#__PURE__*/React.createElement("a", {
          href: "/cart",
          className: 'cb-location-banner__shop-button'
        }, /*#__PURE__*/React.createElement(Button, {
          className: "cb-button-unstyled cb-location-banner__shop-button__button"
        }), /*#__PURE__*/React.createElement("span", {
          className: "cb-location-banner__shop-button__indicator"
        }, _this3.state.cartLength))))) : null), /*#__PURE__*/React.createElement(MediaQuery, {
          minWidth: 991
        }, /*#__PURE__*/React.createElement(Col, {
          className: "d-flex justify-content-start align-items-center cb-location-banner__info"
        }, /*#__PURE__*/React.createElement(LocationInfo, {
          location: _this3.props.location,
          store: _this3.props.store,
          isLoading: _this3.props.isLoading,
          isError: _this3.props.isError,
          err: _this3.props.err,
          changeLocationHandler: _this3.props.toggleChangeModal
        })), !_this3.props.isLoading ? /*#__PURE__*/React.createElement(Col, {
          className: "d-flex justify-content-end align-items-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "cb-button-group  d-flex"
        }, Boolean(_this3.props.temporarilyClosed) && /*#__PURE__*/React.createElement("span", {
          className: "d-flex",
          style: {
            'maxWidth': '260px'
          }
        }, "This location is temporarily closed"), Boolean(_this3.props.orderOnline) && /*#__PURE__*/React.createElement("span", {
          className: "d-flex",
          style: {
            'maxWidth': '260px'
          }
        }, "Online ordering is currently unavailable.", /*#__PURE__*/React.createElement("wbr", null), " Please call the store to place your order"), !_this3.props.temporarilyClosed && /*#__PURE__*/React.createElement(React.Fragment, null, _this3.props.waitlistAvailable && /*#__PURE__*/React.createElement(WaitlistButton, {
          store: _this3.props.store,
          ctaClick: ctaClick
        }), /*#__PURE__*/React.createElement("a", {
          href: "/menu",
          className: "cb-button-primary btn-sm cb-location-banner__menu",
          onClick: ga
        }, !_this3.state.isCartAvailable ? 'Order Online' : 'Keep Shopping'), Boolean(_this3.state.isCartAvailable) && /*#__PURE__*/React.createElement("a", {
          href: "/cart",
          className: 'cb-location-banner__shop-button'
        }, /*#__PURE__*/React.createElement(Button, {
          className: "cb-button-unstyled cb-location-banner__shop-button__button"
        }), /*#__PURE__*/React.createElement("span", {
          className: "cb-location-banner__shop-button__indicator"
        }, _this3.state.cartLength))))) : null)))));
      }.bind(this));
    }
  }]);

  return LocationBanner;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  var _state$location, _state$location$locat, _state$location$locat2;

  return {
    waitlistActive: state.waitlist.waitlistActive,
    waitlistLoading: state.waitlist.isLoading,
    waitlistConfirmation: state.waitlist.confirmation,
    showForm: state.waitlist.showForm,
    waitlistAvailable: UTIL.locationUtil.isWaitListAvailable(state === null || state === void 0 ? void 0 : (_state$location = state.location) === null || _state$location === void 0 ? void 0 : _state$location.location),
    orderOnline: (_state$location$locat = state.location.location) === null || _state$location$locat === void 0 ? void 0 : _state$location$locat.OnlineOrdering,
    temporarilyClosed: (_state$location$locat2 = state.location.location) === null || _state$location$locat2 === void 0 ? void 0 : _state$location$locat2.TemporarilyClosed,
    location: state.location.location,
    results: state.location.results,
    additionalResults: state.location.additionalResults,
    isLoading: state.location.isLoading,
    isError: state.location.isError,
    err: state.location.err,
    changeLocationModal: state.location.changeLocationModal,
    changeNoLocationModal: state.location.changeNoLocationModal,
    cart: state.cart.destructuredCart
  };
}; // TODO: Move the rest of the operations outside of thhe main component


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    toggleChangeModal: function toggleChangeModal() {
      return dispatch(locationOperations.toggleChangeModal());
    },
    //toggleChangeNoLocationModal: () => dispatch(locationOperations.toggleChangeNoLocationModal()),
    requestFromUrl: function requestFromUrl(address) {
      return dispatch(locationOperations.requestFromUrl(address));
    },
    getLocationFromUrl: function getLocationFromUrl() {
      return dispatch(locationOperations.getLocationFromUrl());
    },
    toggleWaitlist: function toggleWaitlist() {
      return dispatch(waitlistOperations.toggleWaitlist());
    },
    requestById: function requestById(ids) {
      return dispatch(locationOperations.requestById(ids));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationBanner);